module.exports = "<bl-reset-change-password-modal (success)=\"redirectToLogin()\" [from_app]=\"from_app\"></bl-reset-change-password-modal>\n"